// extracted by mini-css-extract-plugin
export var carrierTab = "_66-0";
export var carrierTabActive = "_66-1 _66-0";
export var carrierTabInactive = "_66-2 _66-0";
export var carrierTabLabel = "_66-3";
export var carrierTabLabelActive = "_66-4 _66-3";
export var carrierTabLabelInactive = "_66-5 _66-3";
export var carrierTabPercentage = "_66-6";
export var carrierTabPercentageActive = "_66-7 _66-6";
export var carrierTabPercentageInactive = "_66-8 _66-6";
export var carrierTabWinnable = "_66-9";
export var carrierTabWinnableActive = "_66-a _66-9";
export var carrierTabWinnableInactive = "_66-b _66-9";
export var comparisonContainer = "_66-d";
export var missingRateButton = "_66-n";
export var missingRateButtonActive = "_66-o _66-n";
export var missingRateButtonInactive = "_66-p _66-n";
export var missingRateButtonLabel = "_66-q";
export var missingRateButtonLabelActive = "_66-r _66-q";
export var missingRateButtonLabelInactive = "_66-s _66-q";
export var sidebar = "_66-c";
export var strategyButton = "_66-e";
export var strategyButtonActive = "_66-f _66-e";
export var strategyButtonDescription = "_66-k";
export var strategyButtonDescriptionActive = "_66-l _66-k";
export var strategyButtonDescriptionInactive = "_66-m _66-k";
export var strategyButtonInactive = "_66-g _66-e";
export var strategyButtonLabel = "_66-h";
export var strategyButtonLabelActive = "_66-i _66-h";
export var strategyButtonLabelInactive = "_66-j _66-h";
export var unitToggleButton = "_66-t";
export var unitToggleButtonActive = "_66-u _66-t";
export var unitToggleButtonInactive = "_66-v _66-t";
export var unitToggleButtonLabel = "_66-w";
export var unitToggleButtonLabelActive = "_66-x _66-w";
export var unitToggleButtonLabelInactive = "_66-y _66-w";